<template>
    <span>{{ username }}</span>
</template>

<script>
export default {
    computed: {
        username() {
            return this.$store.state.user.first_name
        }
    }
}
</script>
